import React from 'react';

const PriceBreakdown = () => {
  const items = [
    { label: 'Land Value (est.)', value: '$1,680,000', pct: '60%', color: '#00D4FF' },
    { label: 'Dwelling Value (est.)', value: '$840,000', pct: '30%', color: '#00FF88' },
    { label: 'Location Premium', value: '$280,000', pct: '10%', color: '#FFAA00' },
  ];
  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Price Breakdown</h3>
      <div className="space-y-4">
        {items?.map((item, i) => (
          <div key={i}>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-muted-foreground">{item?.label}</span>
              <span className="font-medium text-foreground">{item?.value}</span>
            </div>
            <div className="h-2 rounded-full bg-muted overflow-hidden">
              <div className="h-full rounded-full transition-all duration-700" style={{ width: item?.pct, background: item?.color }} />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border grid grid-cols-2 gap-4">
        <div className="text-center p-3 rounded-lg bg-muted/30">
          <p className="text-xl font-bold text-foreground">$1,867</p>
          <p className="text-xs text-muted-foreground">per m² (est.)</p>
        </div>
        <div className="text-center p-3 rounded-lg bg-muted/30">
          <p className="text-xl font-bold" style={{ color: '#00FF88' }}>Fair</p>
          <p className="text-xs text-muted-foreground">vs suburb avg $1,820/m²</p>
        </div>
      </div>
    </div>
  );
};

export default PriceBreakdown;
